import {
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    ButtonGroup,
    Button,
} from '@design-system-etat/dsfr-react';
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ModaleArmeNonSoumiseADeclaration2011 = ({ etapeSuivante, fermerModale, retourArriere }) => {
    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <>
            <ModalV2
                id="modale-ajouter-arme"
                idModalTitle="modale-ajouter-arme-title"
                size="lg"
                onClose={fermerModale}
                ref={dialog}
            >
                <ModalV2Content>
                    <ModalV2Title id="modale-ajouter-arme-title">
                        Ajouter une arme absente du râtelier
                    </ModalV2Title>

                    <p>
                        Les informations correspondent à une arme acquise avant le 1er décembre 2011
                        (décret n°2011-1523 du 7 octobre 2011)
                    </p>
                    <p>
                        Il n&apos;est pas obligatoire de déclarer cette arme mais vous pouvez le
                        faire afin qu&apos;elle soit ajoutée à votre râtelier numérique.
                    </p>
                </ModalV2Content>
                <ModalV2Footer>
                    <ButtonGroup align="right" inline>
                        <Button onClick={retourArriere}>Ne pas déclarer cette arme</Button>
                        <Button variant="primary" onClick={etapeSuivante}>
                            Déclarer cette arme
                        </Button>
                    </ButtonGroup>
                </ModalV2Footer>
            </ModalV2>
        </>
    );
};

ModaleArmeNonSoumiseADeclaration2011.propTypes = {
    etapeSuivante: PropTypes.func.isRequired,
    fermerModale: PropTypes.func.isRequired,
    retourArriere: PropTypes.func.isRequired,
};

export default ModaleArmeNonSoumiseADeclaration2011;
